import { Big, Float } from "./helper";
import { RowType } from "../../../components/Editable/FormItem/Rows/RowType";

export function calculateSummary(items, appliedLinkItems, taxMode, isRoundingOn) {
    let subtotalB = Big();
    let discountB = Big();
    let salesTaxB = Big();
    let serviceTax6B = Big();
    let serviceTax8B = Big();
    let serviceTaxExemptedC1B = Big();
    let serviceTaxExemptedC2B = Big();
    let serviceTaxExemptedC3B = Big();

    // console.log('aaa1 calculateSummary pre-0', {
    //     items,
    //     taxMode,
    //     isRoundingOn,
    // });

    function calculateServiceTaxAmount(rate, amount) {
        if (rate === 6)
            serviceTax6B = serviceTax6B.plus(amount);
        else if (rate === 8)
            serviceTax8B = serviceTax8B.plus(amount);
    }

    // will update in-place to the above let variables
    function updateTaxBreakdown(record) {
        const {
            sales_tax_amount,
            service_tax, // Either array: [{rate, amount}] or just the object itself. Array is used for product bundle.
            service_tax_exempted_amount,
            // Bundle-only: per-category exempted amounts
            service_tax_exempted_c1_amount,
            service_tax_exempted_c2_amount,
            service_tax_exempted_c3_amount,
        } = record.tax_amount_breakdown;

        // Sales Tax
        salesTaxB = salesTaxB.plus(sales_tax_amount);

        // Service Tax (6% or 8%)
        if (Array.isArray(service_tax)) {
            service_tax.forEach(({ rate, amount }) => {
                calculateServiceTaxAmount(rate, amount);
            });
        }
        else {
            calculateServiceTaxAmount(service_tax?.rate, service_tax?.amount);
        }

        // Tax Exempted
        // Bundles provide per-category amounts directly; normal items use tax_code.
        if (
            service_tax_exempted_c1_amount !== undefined ||
            service_tax_exempted_c2_amount !== undefined ||
            service_tax_exempted_c3_amount !== undefined
        ) {
            // Bundle: each category tracked separately
            serviceTaxExemptedC1B = serviceTaxExemptedC1B.plus(service_tax_exempted_c1_amount || 0);
            serviceTaxExemptedC2B = serviceTaxExemptedC2B.plus(service_tax_exempted_c2_amount || 0);
            serviceTaxExemptedC3B = serviceTaxExemptedC3B.plus(service_tax_exempted_c3_amount || 0);
        }
        else if (record?.tax_code === "SVE8C1" || record?.tax_code === "SVEC1") {
            serviceTaxExemptedC1B = serviceTaxExemptedC1B.plus(service_tax_exempted_amount).round(2);
        }
        else if (record?.tax_code === "SVE8C2" || record?.tax_code === "SVEC2") {
            serviceTaxExemptedC2B = serviceTaxExemptedC2B.plus(service_tax_exempted_amount).round(2);
        }
        else if (record?.tax_code === "SVE8C3" || record?.tax_code === "SVEC3" || record?.tax_code === "SV6E2") {
            serviceTaxExemptedC3B = serviceTaxExemptedC3B.plus(service_tax_exempted_amount).round(2);
        }
    }

    items.forEach(record => {
        switch (record.type) {
            case RowType.subtotal:
            case RowType.subtitle:
                break;
            case RowType.item:
            case RowType.bundle:
            default: {
                subtotalB = subtotalB.plus(record.amount || 0);
                if (taxMode === 'inclusive')
                    subtotalB = subtotalB.minus(record.tax_amount || 0); // total tax amount

                discountB = discountB.minus(record.discount_amount || 0);
                updateTaxBreakdown(record);
                break;
            }
            // default: { // item, bundle (parent)
            //     console.log('line3a', record.type);
            //     subtotalB = subtotalB.plus(record.amount || 0);
            //     if (taxMode === 'inclusive' && !record.is_service_tax_exempted)
            //         subtotalB = subtotalB.minus(record.tax_amount || 0);

            //     discountB = discountB.minus(record.discount_amount || 0);

            //     // Different Tax (Sales Tax, Service Tax)
            //     switch (record.tax_system) {
            //         case "mysst_sales_tax":
            //             salesTaxB = salesTaxB.plus(record.tax_amount || 0);
            //             break;
            //         case "mysst_service_tax":
            //             serviceTaxB = serviceTaxB.plus(record.tax_amount || 0);
            //             break;
            //         default:
            //             break;
            //     }

            //     // Tax Exempted (B2B etc.)
            //     if (record.is_service_tax_exempted)
            //         serviceTaxExemptedB = serviceTaxExemptedB.minus(record.tax_amount || 0);
            // }
        }
    });

    // Tax Total
    const taxB = salesTaxB.plus(serviceTax6B).plus(serviceTax8B);

    // Grand Total
    const totalBeforeRoundingB = subtotalB.plus(discountB).plus(taxB);

    // 5-cent rounding
    const totalAfterRoundingB = Big(Math.ceil(totalBeforeRoundingB.times(20)
        .minus(0.5)))
        .div(20);
    const roundingB = totalAfterRoundingB.minus(totalBeforeRoundingB);
    const totalB = isRoundingOn ? totalAfterRoundingB : totalBeforeRoundingB;

    // console.log('aaa1 calculateSummary 2', {
    //     subtotal: Float(subtotalB),
    //     tax: Float(taxB),
    //     rounding: Float(roundingB),
    //     totalBeforeRounding: Float(totalBeforeRoundingB),
    //     totalAfterRounding: Float(totalAfterRoundingB),
    //     total: Float(totalB),
    // });

    // Balance Calculation (with Invoice Applied Link Items)
    let balanceB = totalB;
    const appliedLinkItems2 = appliedLinkItems.map(linkItem => {
        let applyAmountB = Big(linkItem.apply_amount);
        if (linkItem.apply_amount === undefined) {
            applyAmountB = (
                balanceB.gte(Big(linkItem.balance)) ?
                    Big(linkItem.balance) :
                    balanceB
            );
        }
        balanceB = balanceB.minus(applyAmountB);
        return {
            ...linkItem,
            apply_amount: Float(applyAmountB),
        };
    });

    // console.log('aaa1 calculateSummary 3', {
    //     balance: Float(balanceB),
    //     appliedLinkItems,
    //     rounding: Float(roundingB),
    //     subtotal: Float(subtotalB),
    // });

    return {
        summary: {
            subtotal: Float(subtotalB),
            discount: Float(discountB),
            sales_tax: Float(salesTaxB),
            service_tax_6: Float(serviceTax6B),
            service_tax_8: Float(serviceTax8B),
            service_tax_exempted_c1: Float(serviceTaxExemptedC1B),
            service_tax_exempted_c2: Float(serviceTaxExemptedC2B),
            service_tax_exempted_c3: Float(serviceTaxExemptedC3B),
            tax: Float(taxB),
            rounding: Float(roundingB),
            total: Float(totalB),
            balance: Float(balanceB),
        },
        appliedLinkItems: appliedLinkItems2,
    };
}
